
<template>
    <vx-card title="Partners" class="mb-base">
        <div class="mt-5">
            <e-charts autoresize :options="bar" ref="bar" theme="ovilia-green" auto-resize />
        </div>
    </vx-card>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import theme from './theme.json'
import PartnerService from "@/services/PartnerService";

ECharts.registerTheme('ovilia-green', theme)

export default {
  data () {
    return {
      source:[],
      bar: {
        legend: {},
        tooltip: {},
        totalClientCount : [0,0,0,0,0,0,0,0,0,0,0,0],
        totalActiveClientCount : [0,0,0,0,0,0,0,0,0,0,0,0],
        dataset: {
          source:  [['Product', 'Total', 'Active']]
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [{ type: 'bar' }, { type: 'bar' }],
        color: ['#fc0303']
      }
    }
  },
  methods: {
    getPartners(){
      let source = [];
      if(this.userInfo){
        PartnerService.getAll(this.userInfo).on("value", (items) => {
       this.totalPartnerCount = [0,0,0,0,0,0,0,0,0,0,0,0]
          this.totalActivePartnerCount = [0,0,0,0,0,0,0,0,0,0,0,0]
          items.forEach((item) => {
            let key = item.key;
            let data = item.val();
               if(data['IsDeleted'] == 0){
               let month = new Date(data['CreatedDate']).getMonth()
               for(let i=0;i<12;i++)
               {
                 if(month===i)
                 {
                   this.totalPartnerCount[i] += 1;
                   (data['Status']=='Active' || data['IsActive']==1) ? this.totalActivePartnerCount[i]++ : 0;
                 }
               }
               
            }
          });
          for(let j=0;j<12;j++){
             if(j===0){
             source.push(['Jan',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===1){
             source.push(['Feb',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===2){
             source.push(['Mar',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===3){
             source.push(['Apr',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===4){
             source.push(['May',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===5){
             source.push(['June',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===6){
             source.push(['July',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===7){
             source.push(['Aug',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===8){
             source.push(['Sep',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }else if(j===9){
             source.push(['Oct',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }if(j===10){
             source.push(['Nov',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             }if(j===11){
             source.push(['Dec',[this.totalPartnerCount[j]],[this.totalActivePartnerCount[j]]])
             } 
            } 
            this.bar.dataset.source = source
        });
          
      }
    }
  },
  mounted(){
     this.getPartners()
  },
  created(){
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
  },
  components: {
    ECharts
  }
}
</script>
